import { render, staticRenderFns } from "./FornecedorWFDetalheContato.vue?vue&type=template&id=37a22677&"
import script from "./FornecedorWFDetalheContato.vue?vue&type=script&lang=js&"
export * from "./FornecedorWFDetalheContato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports